import { useMemo } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";
import Hero from "./components/Hero";
import StatsBand from "./components/StatsBand";
import CategorySection from "./components/CategorySection";
import LatestStatements from "./components/LatestStatements";
import PrinciplesSection from "./components/PrinciplesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqPreview from "./components/FaqPreview";
import ContactCta from "./components/ContactCta";

export default function Home() {
  const jsonLd = useMemo(() => {
    const prefix = __BASE_PATH__.split("/").filter(Boolean).join("/");
    const base = typeof window !== "undefined" ? window.location.origin : "https://example.com";
    const home = `${base}${prefix ? `/${prefix}` : ""}`;

    return [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        alternateName: siteInfo.fullName,
        url: `${home}/`,
        description: siteInfo.intro,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${home}/statements?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: `${home}/`,
        email: siteInfo.email,
        description: siteInfo.fullName,
        contactPoint: {
          "@type": "ContactPoint",
          email: siteInfo.email,
          contactType: "customer support",
          availableLanguage: ["zh-CN"],
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 4).map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
    ];
  }, []);

  useSeo({
    title: "黑料官方 - 官方声明辟谣澄清公告查询与信息核实平台",
    description:
      "黑料官方集中归档官方声明、辟谣澄清、官方回应与公告通知原文，按时间与类别整理。传闻四起时，先在这里核对官方口径、发布时间与核实结论。",
    keywords: "黑料官方,官方声明,黑料官方辟谣,官方回应,澄清公告,信息核实",
    path: "/",
    jsonLd,
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <StatsBand />
        <CategorySection />
        <LatestStatements />
        <PrinciplesSection />
        <TestimonialsSection />
        <FaqPreview />
        <ContactCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}